import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export type ModuleStatus = 'completed' | 'in_progress' | 'not_started';

export interface ICourseModule {
  id: number
  title: string
  description?: string
  image_url?: string | null
  lessons_count: number
  module_status: ModuleStatus
  [key: string]: any
}

export interface ICourse {
  id: number
  name: string
  description?: string
  image_url?: string | null
  user_status?: string
  has_certificate?: boolean
  has_achievement?: boolean
  achievement?: any
  lessons_count?: number
  modules: ICourseModule[]
  [key: string]: any
}

export const FALLBACK_IMAGE = 'https://assets.hackingclub.com/course/avatar/webapp.png';

// Módulo que o aluno deve abrir agora: o primeiro em andamento, senão o primeiro a fazer
export const currentModuleOf = (modules: ICourseModule[] = []): ICourseModule | null =>
  modules.find(module => module.module_status === 'in_progress')
  ?? modules.find(module => module.module_status === 'not_started')
  ?? null;

export const useCourseI18n = () => {
  const { t } = useI18n();
  const store = useStore();
  const lang = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage') || 'en');
  const tc = (key: string, params: Record<string, unknown> = {}) => t(`${lang.value}.course_view.${key}`, params);
  return { t, lang, tc };
};
